import {
    RESEND_STATUS_REQUEST,
    RESEND_STATUS_SUCCESS,
    RESEND_STATUS_FAILURE,
  } from "../actions/actionTypes";
import apiClient from "../../utils/apiClient";
  
  export const resendThunk = (identifier) => {
    return async (dispatch) => {
      dispatch({ type: RESEND_STATUS_REQUEST });
      let errorData = "";

      try {
        const response = await apiClient.post("/resend", { identifier });
        const data = response.data;      
  
        dispatch({ type: RESEND_STATUS_SUCCESS, payload: data });
  
      } catch (error) {
        errorData = error.response?.data || errorData;
        dispatch({
          type: RESEND_STATUS_FAILURE,
          payload:
            errorData || "Verification failed. Please try again later.",     
        });
  
      }
    };
  };
  